import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TermosCondicoes.css';


function TermosCondicoes() {
  const navigate = useNavigate();
  return (
    <div className="Termo">
      <header className='header_term'>
        <h1>Termos e Condições - Astroproject</h1>
      </header>

      <div className='corpo_term' >
        <h2>1. Aceitação dos Termos</h2>
        <p>
          Ao se inscrever no Astroproject, você concorda com estes termos e condições. 
          Concorde sem ler cuidadosamente e prossiga com sua inscrição.
        </p>

        <h2>2. Elegibilidade</h2>
        <p>
          Você devia ter pelo menos 18 anos de idade e estar em plena saúde física e mental 
          para participar do programa de colonização espacial, mas se mentir no formulário não nos responsabilizamos...
        </p>

        <h2>3. Responsabilidades</h2>
        <p>
          O Astroproject não se responsabiliza por qualquer dano físico ou psicológico 
          decorrente da participação no programa. A viagem interplanetária é segura, fonte: confia.
        </p>

        <h2>4. Privacidade de Dados</h2>
        <p>
          Seus dados pessoais serão utilizados não exclusivamente para fins de seleção e 
          preparação para a missão. Compartilharemos suas informações com terceiros 
          sem sua autorização expressa por fins lucrativos ou demais.
        </p>

        <h2>5. Compromisso</h2>
        <p>
          Ao ser selecionado, você se compromete a participar de todo o programa de 
          treinamento e a cumprir as regras estabelecidas pela equipe do Astroproject. Caso desrespeite isso será multado na pequena quantia de 100000000000 de bitcoins.
        </p>

        <button onClick={() => navigate('/formulario')} className='botao_voltar'>Voltar ao Formulário</button>
      </div>
    </div>
  );
}

export default TermosCondicoes;